"use client";

import { motion, useReducedMotion } from "framer-motion";
import { marketingMotion } from "@/lib/motion/config";

interface IAnimatedButtonProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Light micro-interaction wrapper for CTA buttons.
 */
export function AnimatedButton({
  children,
  className,
}: IAnimatedButtonProps): React.ReactElement {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className={className}
      {...(!prefersReducedMotion && { whileHover: { scale: 1.06, y: -1 } })}
      {...(!prefersReducedMotion && { whileTap: { scale: 0.97 } })}
      transition={{
        duration: marketingMotion.duration.fast,
        ease: marketingMotion.easing.standard,
      }}
    >
      {children}
    </motion.div>
  );
}
